
import { AxiosClient } from "../../utils/axios";
import IntroContact from "./IntroContact.vue";
import Loading from "../Loading.vue";
import { message as alertMessage } from "ant-design-vue";

export default {
  props: [
    "contacts",
    "description",
    "website",
    "target",
    "method",
    "email",
    "tuition_min",
    "tuition_max",
    "schoolId", // ID of current school page, e.g. 99, 97, 98
    // School ID mapping:
    // 99  → Trường Đại học Bách khoa (https://mediahub.tuoitre.vn/eduzone/school/99)
    // 97  → Trường Đại học Khoa học Tự nhiên (https://mediahub.tuoitre.vn/eduzone/school/97)
    // 98  → Trường Đại học Khoa học Xã hội và Nhân văn (https://mediahub.tuoitre.vn/eduzone/school/98)
    // 117 → Trường Đại học Công nghệ Thông tin (https://mediahub.tuoitre.vn/eduzone/school/117)
    // 130 → Trường Đại học Kinh tế - Luật (https://mediahub.tuoitre.vn/eduzone/school/130)
  ],
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      introLoadFullText: false,
      methodContentLoadFullText: false,
      showModal: false, // controls khongtrung popup visibility
      showConfirmPlay: false, // popup kết quả (confirmplay hoặc khongtrungchucmayman)
      playResult: null, // response từ API lucky-draw/game/play
      isWin: false, // data.data.isWin từ API
      treasureState: "form", // form | btc | btcWarning | awarded
      isClaiming: false, // loading khi gọi game/claim
      claimName: "",
      claimEmail: "",
      claimPhone: "",
      isLoading: false,
      overflow: {
        intro: {
          isOverflow: false,
          isExpanded: false,
          desc: {
            isOverFlow: false,
            isExpanded: false,
          },
        },
        admission: {
          isOverflow: false,
          isExpanded: false,
        },
      },
    };
  },
  components: {
    IntroContact,
    Loading,
  },
  methods: {
    getAddressTitle(index) {
      // Nếu chỉ có 1 item trong mảng thì hiển thị "Địa chỉ cũ"
      if (this.contacts.length === 1) {
        return "Địa chỉ cũ:";
      }
      // Nếu có hơn 1 item thì hiển thị "Địa chỉ {index + 1}"
      return `Địa chỉ ${index + 1}:`;
    },
    formatStablePhone: function (phoneNumber) {
      return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1.$2.$3");
    },
    formatMobilePhone: function (phoneNumber) {
      return phoneNumber.replace(/(\d{4})(\d{3})(\d{3})/, "$1.$2.$3");
    },
    handleIntroDescReadMore() {
      if (!this.overflow.intro.desc.isOverFlow) {
        this.overflow.intro.isExpanded = false;
      }
      this.overflow.intro.desc.isOverFlow =
        !this.overflow.intro.desc.isOverFlow;
    },
    handleExpanding(name) {
      switch (name) {
        case "intro":
          if (!this.overflow.intro.isExpanded) {
            this.overflow.intro.desc.isOverFlow = false;
          } else {
            this.overflow.intro.desc.isOverFlow = false;
          }
          this.overflow.intro.isExpanded = !this.overflow.intro.isExpanded;

          break;
        default:
          this.overflow[name].isExpanded = !this.overflow[name].isExpanded;
          break;
      }
    },
    handlingIntroDesc(value) {
      if (value && value.length > 1) {
        const introDescFullRef = this.$refs.introDescFullRef;
        const introDescSliceRef = this.$refs.introDescSliceRef;
        const holdElement = document.createElement("span");
        holdElement.innerHTML = value ? value.replaceAll("&nbsp;", " ") : value;
        if (
          (holdElement.getElementsByTagName("p") &&
            holdElement.getElementsByTagName("p").length > 1) ||
          holdElement.innerHTML.length > 200
        ) {
          const collapseElement = document.createElement("span");
          collapseElement.className = "load-full-content";
          collapseElement.addEventListener(
            "click",
            this.handleIntroDescReadMore,
          );
          collapseElement.textContent = "Thu gọn";
          introDescFullRef.innerHTML = value;
          introDescFullRef.appendChild(collapseElement);
          const loadMoreElement = document.createElement("span");
          loadMoreElement.className = "load-full-content";
          loadMoreElement.addEventListener(
            "click",
            this.handleIntroDescReadMore,
          );
          loadMoreElement.textContent = "Xem thêm";
          const dotElement = document.createElement("span");
          dotElement.textContent = "...";
          const firstTag = document.createElement("div");
          const array = holdElement
            .getElementsByTagName("p")[0]
            .innerText.split(" ")
            .splice(0, 54);
          const string = array.toString().replaceAll(",", " ");
          firstTag.innerText = string;
          firstTag.appendChild(dotElement);
          firstTag.appendChild(loadMoreElement);
          introDescSliceRef.appendChild(firstTag);
          this.overflow.intro.desc.isOverFlow = true;
        } else {
          introDescFullRef.innerHTML = value ? value.replaceAll("&nbsp;", " ") : value;
          // introDescFullRef.innerHTML = value ? value.replaceAll(" ") : value;
          this.overflow.intro.desc.isOverFlow = false;
        }
        // const introRef = this.$refs.introRef;
        // const limitedHeight = 360;
        // if (introRef.clientHeight > limitedHeight) {
        //   this.overflow.intro.isOverflow = true;
        //   introRef.style.height = `${limitedHeight}px`;
        // }
      }
    },
    handleCheckWinPrize() {},
    async handleSubmit() {
      if (this.isClaiming) return;

      if (!this.claimName || !this.claimPhone) {
        alertMessage.error("Vui lòng nhập đầy đủ Họ Tên và Số Điện Thoại.");
        return;
      }

      const winnerId = this.playResult?.data?.winner?.id;
      if (!winnerId) {
        alertMessage.error("Không tìm thấy thông tin lượt trúng thưởng.");
        return;
      }

      const payload = {
        winner_id: winnerId,
        metadata: {
          prize_recipient_name: this.claimName,
          prize_recipient_phone: this.claimPhone,
          prize_recipient_email: this.claimEmail,
        },
      };

      try {
        this.isClaiming = true;
        this.isLoading = true;
        const response = await AxiosClient.post(
          "/eduzone/api/sso_v1/lucky-draw/game/claim",
          payload,
          { withCredentials: true },
        );
        const data = response.data;
        console.log("[CLAIM SUCCESS] Response:", data);
        this.playResult = data;
        this.isWin = true;
        this.treasureState = "btc";
        alertMessage.success("Đã gửi thông tin nhận quà.");
      } catch (err) {
        console.error("[CLAIM ERROR] Request failed:", err);
        alertMessage.error(
          "Gửi thông tin nhận quà thất bại, vui lòng thử lại.",
        );
      } finally {
        this.isClaiming = false;
        this.isLoading = false;
      }
    },
    handleBtcSkip() {
      this.treasureState = "btc";
    },
    async handleBtcAgree() {
      const winnerId = this.playResult?.data?.winner?.id;
      if (!winnerId) return;

      this.isLoading = true;
      try {
        const response = await AxiosClient.post(
          "/eduzone/api/sso_v1/lucky-draw/game/award",
          { winner_id: winnerId, metadata: null },
          { withCredentials: true },
        );
        console.log("[AWARD SUCCESS]", response.data);
        this.treasureState = "awarded";
      } catch (e) {
        console.error("[AWARD ERROR]", e);
        alertMessage.error("Xác nhận từ BTC thất bại, vui lòng thử lại.");
      } finally {
        this.isLoading = false;
      }
    },
    async handleStartGold(event) {
      // prevent any default navigation/propagation that might be bubbling
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      // Reset popup states to prevent cached display
      this.showModal = false;
      this.showConfirmPlay = false;

      console.log(
        "%c[BUTTON CLICK] handleStartGold invoked",
        "background: #FFD700; color: black; font-weight: bold;",
      );
      console.log("[BUTTON CLICK] current location:", window.location.href);
      // set store flag so any accidental get-list-group-major call gets skipped
      this.$store.commit("Major/SET_PREVENT_MAJOR_API", true);

      // verify userInfo exists (login state sometimes derived)
      const userInfo = this.$store.state.userInfo?.info || {};
      if (!userInfo.id) {
        // Redirect to login page with redirect URL
        const currentUrl = process.client
          ? window.location.pathname + window.location.search
          : "";
        const loginUrl = `https://mediahub.tuoitre.vn/login?redirectUrl=${encodeURIComponent(
          currentUrl,
        )}`;
        // const loginUrl = `https://stag-mediahub.tuoitre.vn/login?redirectUrl=${encodeURIComponent(currentUrl)}`;
        console.log("[LOGIN REDIRECT] Redirecting to login page:", loginUrl);
        if (process.client) {
          window.location.href = loginUrl;
        }
        return;
      }
      // Get school ID from API response (prop) or from URL route
      let currentSchoolId = this.schoolId;

      // Fallback: get from route params if prop not available
      if (!currentSchoolId && this.$route.params.id) {
        // Extract numeric ID from slug (e.g., "99" or "99-truong-dai-hoc")
        const idMatch = String(this.$route.params.id).match(/^(\d+)/);
        currentSchoolId = idMatch
          ? parseInt(idMatch[1], 10)
          : this.$route.params.id;
      }

      console.log("[SCHOOL ID] Current school ID:", currentSchoolId);
      console.log("[SCHOOL ID] Route:", this.$route.path);
      console.log("[SCHOOL ID] Route params:", this.$route.params);

      if (!currentSchoolId) {
        alertMessage.error(
          "Không thể xác định trường, vui lòng tải lại trang.",
        );
        return;
      }

      this.isLoading = true;
      try {
      // 1. Gọi my-prizes TRƯỚC TIÊN để kiểm tra xem user này đã từng chơi/có giải chưa
      let shouldCallPlay = true;
      try {
        const myPrizesRes = await AxiosClient.get(
          "/eduzone/api/sso_v1/lucky-draw/game/my-prizes",
          {
            // Bỏ school_id để lấy lịch sử chơi chung của user trên toàn event
            params: { event_code: "EZ_SKB_26" },
            withCredentials: true,
          },
        );
        const list = myPrizesRes?.data?.data;
        if (Array.isArray(list) && list.length > 0) {
          const item = list[0];
          console.log("[MY-PRIZES] User already played:", item);

          const claimedAt = item.claimedAt != null ? item.claimedAt : null;
          const awardedAt = item.awardedAt != null ? item.awardedAt : null;
          const playResultFromMyPrizes = {
            data: {
              winner: {
                id: item.winnerId,
                memberName: item.memberName,
                memberEmail: item.memberEmail,
                memberPhone: item.memberPhone,
                prize: item.prize,
                claimedAt,
                awardedAt,
                metadata: item.metadata,
              },
              isWin: item.isWin ?? false,
            },
          };
          this.playResult = playResultFromMyPrizes;
          this.isWin = item.isWin ?? false;

          shouldCallPlay = false;
          this.showConfirmPlay = true;

          if (this.isWin) {
            // Tự động điền dữ liệu cho Form
            const userInfo = this.$store.state.userInfo?.info || {};
            this.claimName = userInfo.nickname || userInfo.first_name || "";
            this.claimPhone = userInfo.phone || "";
            this.claimEmail = userInfo.email || "";

            if (awardedAt != null) {
              this.treasureState = "awarded";
              return;
            }
            if (claimedAt != null) {
              this.treasureState = "btc";
              return;
            }
            this.treasureState = "form";
            return;
          }
          // Kết thúc hàm, vì isWin = false đã hiện popup "không trúng"
          return;
        }
      } catch (e) {
        console.warn("[MY-PRIZES] Fetch failed", e);
      }

      // 2. Nếu chưa chơi thì mới tiến hành validate trường hợp lệ
      if (shouldCallPlay) {
        // Whitelist: chỉ cho phép chơi game cho 5 trường được hỗ trợ
        const supportedSchools = [99, 97, 98, 117, 130];
        const schoolIdNum = parseInt(currentSchoolId, 10);
        if (!supportedSchools.includes(schoolIdNum)) {
          console.warn(
            "[SCHOOL ID] School",
            schoolIdNum,
            "is not supported. Showing khongtrung.png",
          );
          this.showModal = true;
          return;
        }

        // Check random school id trong localStorage
        const randomSchoolId = localStorage.getItem("eduzone_random_school_id");
        if (randomSchoolId && parseInt(randomSchoolId, 10) !== schoolIdNum) {
          console.warn(
            "[GAME PLAY] School mismatch. Random school is",
            randomSchoolId,
            "but current is",
            schoolIdNum,
          );
          this.showModal = true;
          return;
        }

        // 3. Đủ điều kiện hợp lệ thì gọi lệnh Play game
        const payload = {
          event_code: "EZ_SKB_26",
          metadata: { school_id: currentSchoolId },
        };
        try {
          const response = await AxiosClient.post(
            "/eduzone/api/sso_v1/lucky-draw/game/play",
            payload,
            { withCredentials: true },
          );
          const data = response.data;
          console.log("[API SUCCESS] Response:", data);

          this.playResult = data;
          this.isWin = data?.data?.isWin ?? false;

          this.showConfirmPlay = true;

          if (this.isWin) {
            // Tự động điền thông tin user vào form
            const userInfo = this.$store.state.userInfo?.info || {};
            this.claimName = userInfo.nickname || userInfo.first_name || "";
            this.claimPhone = userInfo.phone || "";
            this.claimEmail = userInfo.email || "";

            this.treasureState = "form";
          }
        } catch (err) {
          console.error("[API ERROR] Fetch failed:", err);
          alertMessage.error("Có lỗi xảy ra, vui lòng thử lại.");
        }
      }
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    isAnyPopupOpen() {
      return this.showModal || this.showConfirmPlay;
    },
    prizeName() {
      return this.playResult?.data?.winner?.prize?.name || "";
    },
    prizeImageUrl() {
      const img = this.playResult?.data?.winner?.prize?.image;
      if (!img) return "";
      if (img.startsWith("http")) return img;
      return (
        "https://stuoixanh.tuoitre.vn" + (img.startsWith("/") ? img : "/" + img)
      );
    },
    recipientName() {
      return (
        this.claimName ||
        this.playResult?.data?.winner?.metadata?.prizeRecipientName ||
        this.playResult?.data?.winner?.memberName ||
        ""
      );
    },
    recipientEmail() {
      return (
        this.claimEmail ||
        this.playResult?.data?.winner?.metadata?.prizeRecipientEmail ||
        this.playResult?.data?.winner?.memberEmail ||
        ""
      );
    },
    recipientPhone() {
      return (
        this.claimPhone ||
        this.playResult?.data?.winner?.metadata?.prizeRecipientPhone ||
        this.playResult?.data?.winner?.memberPhone ||
        ""
      );
    },
  },
  watch: {
    isAnyPopupOpen(newVal, oldVal) {
      if (newVal && !oldVal) {
        window.history.pushState({ miniGamePopup: true }, "");
      } else if (!newVal && oldVal) {
        if (window.history.state && window.history.state.miniGamePopup) {
          window.history.back();
        }
      }
    },
    "overflow.intro.isExpanded"(value) {
      value
        ? ((this.$refs.introRef.style.height = "auto"),
          (this.$refs.introRef.style.overflowY = "auto"))
        : ((this.$refs.introRef.style.height = "360px"),
          (this.$refs.introRef.style.overflowY = "hidden"));
    },
    "overflow.admission.isExpanded"(value) {
      value
        ? ((this.$refs.admissionRef.style.height = "auto"),
          (this.$refs.admissionRef.style.overflowY = "auto"))
        : ((this.$refs.admissionRef.style.height = "360px"),
          (this.$refs.admissionRef.style.overflow = "hidden"));
    },
    "overflow.intro.desc.isExpanded"(value) {
      value
        ? ((this.$refs.introDescRef.style.height = "auto"),
          (this.$refs.introDescRef.style.overflow = "auto"))
        : ((this.$refs.introDescRef.style.height = "100px"),
          (this.$refs.introDescRef.style.overflow = "hidden"));
    },
    method(value) {
      const admissionTargetRef = this.$refs.admissionTarget;
      admissionTargetRef.innerHTML = value ? value.replaceAll("&nbsp;", " ") : value;
      const admissionRef = this.$refs.admissionRef;

      if (admissionRef.clientHeight > 360) {
        admissionRef.style.height = `${360}px`;
        admissionRef.style.overflow = "hidden";
        this.overflow.admission.isOverflow = true;
      }
    },
  },
  mounted() {
    this.handlePopStateBound = (event) => {
      if (this.showModal || this.showConfirmPlay) {
        this.showModal = false;
        this.showConfirmPlay = false;
      }
    };
    window.addEventListener("popstate", this.handlePopStateBound);

    // Xử lý random school ID lưu vào localStorage (nếu chưa có)
    if (
      typeof Storage !== "undefined" &&
      !localStorage.getItem("eduzone_random_school_id")
    ) {
      const idMatch = String(this.$route.params.id).match(/^(\d+)/);
      const urlSchoolId = idMatch
        ? parseInt(idMatch[1], 10)
        : this.$route.params.id;
      const currentSchoolIdNum = parseInt(this.schoolId || urlSchoolId, 10);

      const allSupportedSchools = [99, 97, 98, 117, 130];
      // Lọc bỏ trường đang đứng hiện tại để chắc chắn không random trúng nó
      const filteredSchools = allSupportedSchools.filter(
        (id) => id !== currentSchoolIdNum,
      );
      const supportedSchools =
        filteredSchools.length > 0 ? filteredSchools : allSupportedSchools;

      const randomIndex = Math.floor(Math.random() * supportedSchools.length);
      const randomSchoolId = supportedSchools[randomIndex];
      localStorage.setItem(
        "eduzone_random_school_id",
        randomSchoolId.toString(),
      );
      console.log(
        "[RANDOM SCHOOL INIT] Saved random school into localStorage:",
        randomSchoolId,
      );
    }

    // Log all school ID sources for debugging
    console.log(
      "%c[INIT] School ID Sources:",
      "background: #6494ED; color: white; font-weight: bold;",
    );
    console.log("[INIT] - Props schoolId:", this.schoolId);
    console.log("[INIT] - Route path:", this.$route.path);
    console.log("[INIT] - Route params:", this.$route.params);

    const idMatch = String(this.$route.params.id).match(/^(\d+)/);
    const urlSchoolId = idMatch
      ? parseInt(idMatch[1], 10)
      : this.$route.params.id;
    console.log("[INIT] - Extracted URL school ID:", urlSchoolId);
    console.log("[INIT] - Final school ID:", this.schoolId || urlSchoolId);

    let unformattedPhoneNumber = "39916415";
    this.formatStablePhone(unformattedPhoneNumber);

    if (this.description) {
      this.handlingIntroDesc(this.description);
    }

    const admissionTargetRef = this.$refs.admissionTarget;
    admissionTargetRef.innerHTML = this.method ? this.method.replaceAll("&nbsp;", " ") : this.method;
    const admissionRef = this.$refs.admissionRef;
    if (admissionRef.clientHeight > 360) {
      admissionRef.style.height = `${360}px`;
      admissionRef.style.overflow = "hidden";
      this.overflow.admission.isOverflow = true;
    }

    this.$root.$on("start-minigame-mobile", this.handleStartGold);
  },
  beforeDestroy() {
    if (this.handlePopStateBound) {
      window.removeEventListener("popstate", this.handlePopStateBound);
    }
    this.$root.$off("start-minigame-mobile", this.handleStartGold);
  },
};
